//
//
//
//
//

import xnts from './images/xnts.jpg';
export default {
  data(){
    return {
      xnts
    }
  },
  methods:{
  },
  mounted(){

  }
}



// WEBPACK FOOTER //
// ./src/project/articleProject/xnti.vue